import { createContext, useContext, useState } from "react";
import useFetch from "../hooks/useFetch";
import { pageListFront } from "../services/pageService";

// Create context
const BannerContext = createContext();

// Create provider
export const BannerProvider = ({ children }) => {
  return (
    <BannerContext.Provider
      value={{
        data: [],
        isLoading: false,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => {
  return useContext(BannerContext);
};
